import BaseListPage from "../../../../../base/BaseListPage";
import withRouter from "../../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Table from "../../../../../components/Table";
import UserLogsPresenter from "./UserLogsPresenter";
import { formatDateTime } from "../../../../../utils/dateFormat";

class UserlogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new UserLogsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = [
      "username",
      "login_at",
      "logout_at",
      "device",
      "login_status",
    ];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "user_login_logs";
  }

  formatSchema() {
    return {
      username: { type: "String", label: "Username" },
      login_at: { type: "String", label: "Login At" },
      logout_at: { type: "String", label: "Logout At" },
      device: { type: "String", label: "Device" },
      login_status: { type: "String", label: "Status" },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => ({
      ...object,
      login_at: object.login_at ? formatDateTime(object.login_at) : "—",
      logout_at: object.logout_at ? formatDateTime(object.logout_at) : "—",
    }));
  }

  render() {
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="User Logs"
        navigateBack={this.navigateBack.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <p className="m-0 text-end text-muted" style={{ fontSize: ".875rem" }}>
          Total {objects.length} of {count}
        </p>
        <Table
          fields={this.formatSchema()}
          objects={this.formatObjects(objects)}
          progress={loading}
          excludeFields={[]}
        />
      </PageContainer>
    );
  }
}

export default withRouter(UserlogsPage);
